"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essShreddingModesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const DictionaryEvidence = __importStar(require("../../../composite/evidence/dictionary-evidence/dictionary-evidence"));
const evidence_1 = require("../../../composite/evidence/evidence");
const empty_component_1 = require("../../../utils/empty-component");
const shredding_modes_columns_1 = require("./shredding-modes-columns");
const shredding_modes_fields_1 = require("./shredding-modes-fields");
function essShreddingModesFactory(url, reportTag) {
    return function ShreddingModes() {
        const intl = (0, react_intl_1.useIntl)();
        const evidence = DictionaryEvidence.useDictionaryEvidence({
            identifier: 'ESS_SHREDDING_MODES',
            apiProps: {
                url,
            },
            tableProps: {
                columns: (0, shredding_modes_columns_1.useColumns)(),
                tableName: intl.formatMessage({
                    id: 'ESS_SHREDDING_MODES_TABLE_TITLE',
                    defaultMessage: 'Skartačné režimy',
                }),
                reportTag,
            },
            detailProps: {
                GeneralFieldsComponent: empty_component_1.EmptyComponent,
                FieldsComponent: shredding_modes_fields_1.ShreddingModesFields,
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'ESS_SHREDDING_MODES_DETAIL_TITLE',
                        defaultMessage: 'Skartační režim',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
    };
}
exports.essShreddingModesFactory = essShreddingModesFactory;
//# sourceMappingURL=shredding-modes.js.map